import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: [],
};

export default function tasksReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_TASKS_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_TASKS_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_TASKS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
